import { Value } from "../types";

const addZeroToTime = (time: number) => {
    if (time < 10) {
        return `0${time}`;
    }
    return time;
}


export const formatExtendedDate = (date: Value): string => {
    if (date instanceof Date) {
        const dateFormatOptions: Intl.DateTimeFormatOptions = {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        };

        const formatOfDate = new Intl.DateTimeFormat('pt-BR', dateFormatOptions);
        const dataFormatada = formatOfDate.format(date);

        return dataFormatada;
    }

    return "";
}


export const formatHours = (date: string): string => {
    const newDate = new Date(date);

    let formattedHour = `${addZeroToTime(newDate.getHours())}${newDate.getMinutes() ? `:${addZeroToTime(newDate.getMinutes())}` : ':00'}`;

    return formattedHour;
}


export const formatURL = (url: string, date: Value, siteID: string | null, calendarType : string | null): string => {
    if (date instanceof Date) {
        const newUrl = new URL(url);
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        const formattedDate = `${date.getFullYear()}-${month}-${day}`;
        const minDate = `${formattedDate}T00:00:00Z`;
        const maxDate = `${formattedDate}T23:59:59Z`;

        newUrl.searchParams.append('filter', `startDate ge ${minDate} and startDate le ${maxDate}`);
        newUrl.searchParams.append('sort', 'startDate:asc');
        
        if(calendarType) newUrl.searchParams.append('search', calendarType);

        return `${newUrl.pathname.toString()}/${siteID}` + newUrl.search.toString();
    }

    return '';
}

export const limitText = (text: string, maxSize: number): string => {
    if (text.length > maxSize) {
        return text.slice(0, maxSize) + '...';
    } else {
        return text;
    }
}

